/**
 * This is to allow the spacebar to be used a click enter,
 * in the same way that the return key is used. This is
 * for accessibility purposes.
 */
window.addEventListener('keydown', function handleKeyDown(event) {
  // If space key is pressed & the active element is not the body
  if (event.key === ' ' && document.activeElement !== document.body) {
    // Get currently focused element
    const focused = document.activeElement;

    // Check if the focused element is a button or a link
    if (['BUTTON', 'A'].includes(focused.tagName)) {
      // only prevent default if the element is a button or a link
      // to prevent breaking other accessibility features
      event.preventDefault();
      focused.click();
    }
  }
});
